// pages/ProductDetail.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import products from '../data/products';
import '../styles/productCard.css';

function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = products.find(p => p.id === parseInt(id));

  if (!product) return <p>Product not found</p>;

  return (
    <div className="product-detail">
      <button onClick={() => navigate(-1)}>⬅ Back</button>
      <img src={product.image} alt={product.name} className="product-img" />
      <h1>{product.name}</h1>
      <p>{product.description}</p>
      <h2>${product.price.toFixed(2)}</h2>
      <p>Category: {product.category}</p>
      <p>⭐ Rating: {product.rating}</p>
    </div>
  );
}

export default ProductDetail;
